import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { basename, willNeverHappen } from "healthex-common/utils";
import { observer } from "mobx-react";
import { ImagePreviewDialogParent, MobileImagePreviewDialogParent, PDFPreviewDialogParent, VideoPreviewContainer, ImageCaption, ImagePreview, } from "./FilePreview.styles";
import { MultiPagePDFViewer } from "./MutiPagePDFViewer";
import { HXSimpleDialog } from "./HXSimpleDialog";
import { VideoPlayer } from "./VideoJS/VideoJS";
import { useMobile } from "./mobile";
export function getFilePreviewInfo(file, filetype, existingFileUrl, canPreviewVideoBlob) {
    var _a;
    let filename;
    let url;
    let videoUrlType;
    let isVideoUrlPreviewable = true;
    if (file instanceof File) {
        filename = file.name;
        url = URL.createObjectURL(file);
        videoUrlType = "BLOB";
    }
    else if (file !== null && typeof file === "object" && "sourceUrl" in file) {
        if (file === null || file === void 0 ? void 0 : file.hlsUrl) {
            filename = file.sourceUrl ? basename(file.sourceUrl) : basename(file.hlsUrl);
            url = file.hlsUrl;
            videoUrlType = "HLS";
        }
        else if (file === null || file === void 0 ? void 0 : file.mp4Url) {
            filename = file.sourceUrl ? basename(file.sourceUrl) : basename(file.mp4Url);
            url = file.mp4Url;
            videoUrlType = "MP4";
        }
        else if (file.sourceUrl) {
            filename = basename(file.sourceUrl);
            url = file.sourceUrl;
            videoUrlType = "MP4";
            isVideoUrlPreviewable = false;
        }
        else {
            filename = "Unknown file name";
            url = "unknown";
            videoUrlType = "MP4";
        }
    }
    else if (file !== null) {
        filename = basename(file);
        url = file;
    }
    else if (existingFileUrl) {
        filename = basename(existingFileUrl);
        url = existingFileUrl;
    }
    if (!filename || !url)
        throw new Error("Unexpected combination of parameters");
    let fileExt = (_a = filename.split(".").pop()) !== null && _a !== void 0 ? _a : "";
    if (fileExt)
        fileExt = fileExt.toLowerCase().trim();
    const isVideoBlobFormatPreviewable = !!fileExt && ["mp4", "mov", "mkv"].includes(fileExt.toLowerCase()) && !!canPreviewVideoBlob;
    const isImagePreviewable = [".png", ".jpeg", ".jpg", ".gif", ".webp"].some((ext) => fileExt && ext.endsWith(fileExt));
    let previewable;
    if (filetype === "IMAGE") {
        previewable = isImagePreviewable;
    }
    else if (filetype === "PDF") {
        previewable = true;
    }
    else if (filetype === "VIDEO") {
        previewable = (videoUrlType !== "BLOB" || isVideoBlobFormatPreviewable) && isVideoUrlPreviewable;
    }
    else if (filetype === "CSV") {
        previewable = false;
    }
    else {
        return willNeverHappen(filetype);
    }
    return {
        filename,
        url,
        filetype,
        fileExt,
        videoUrlType,
        previewable,
    };
}
export const ImagePreviewDialog = observer((props) => {
    const isMobile = useMobile();
    const DialogParent = isMobile ? MobileImagePreviewDialogParent : ImagePreviewDialogParent;
    return (_jsxs(DialogParent, { open: props.open, onClose: (_) => props.onClose(), buttons: [], closeChoice: false, title: `Preview: ${props.filename}`, children: [_jsx(ImagePreview, { src: props.url }), props.caption && _jsx(ImageCaption, { children: props.caption })] }));
});
export const PDFPreviewDialog = observer((props) => {
    return (_jsx(PDFPreviewDialogParent, { open: props.open, onClose: (_) => props.onClose(), buttons: [], closeChoice: false, title: `Preview: ${props.filename}`, children: _jsx(MultiPagePDFViewer, { url: props.url }) }));
});
export const VideoPreviewDialog = observer((props) => {
    const previewVideoWidth = 960;
    const previewVideoHeight = 540;
    return (_jsx(HXSimpleDialog, { open: props.open, onClose: (_) => props.onClose(), buttons: [], closeChoice: false, title: `Preview: ${props.filename}`, hasCustomContentAndActions: true, headerHasBottomBorder: true, width: previewVideoWidth, children: _jsx(VideoPreviewContainer, { children: _jsx(VideoPlayer, { hlsUrl: props.videoUrlType === "HLS" ? props.url : undefined, mp4Url: props.videoUrlType === "MP4" ? props.url : undefined, blobUrl: props.videoUrlType === "BLOB" ? props.url : undefined, width: previewVideoWidth, height: previewVideoHeight }) }) }));
});
